import { SVGProps, Ref, forwardRef } from 'react';

export const CubeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M2.934 5.986 12 10.973l9.066-4.987L12 1z" fill="currentColor" />
            <path d="m22 7.527-9.1 5.005V23l9.1-5.005z" fill="currentColor" />
            <path d="M11.1 23V12.532L2 7.527v10.468z" fill="currentColor" />
        </g>
    </svg>
));
CubeFilledSize24Glyph.displayName = 'CubeFilledSize24Glyph';
